import { OasysObjectConfig } from '@app/types/design';
import { ExportValueOrVariable } from '../shared';

export const oasysInputKeys = [
  'autoStartUp',
  'conversationVariables',
  'domain',
  'firstName',
  'lastName',
  'transcript',
  'transientVariables'
] satisfies (keyof(OasysObjectConfig))[];

type InputKey = typeof oasysInputKeys[number];

type LeftoverConfig = Omit<OasysObjectConfig, InputKey>;

export type OasysExportConfig = (
  LeftoverConfig
  & {
    inputs: ExportValueOrVariable[];
  }
);
